import { IUser, useFeatureFlag as useConfigCatFeatureFlag } from 'configcat-react';

import { Provider } from 'src/shared/stores/resource';
import useRootStore from 'src/stores/useRootStore';

export const useFeatureFlag = (
  flagKey: string,
  defaultValue = false,
  userObject?: IUser,
): boolean => {
  const { auth } = useRootStore();
  const user =
    userObject ??
    (auth.user?.id
      ? {
          identifier: auth.user.id,
          email: auth.user.email ?? undefined,
          custom: { role: (auth.user as Provider).teamRole ?? '' },
        }
      : { identifier: 'NO_CONFIGCAT_USER_OBJECT_PROVIDED' });
  const flagValue = useConfigCatFeatureFlag(flagKey, defaultValue, user);
  return !flagValue.loading ? flagValue.value : defaultValue;
};
